module.exports = __webpack_public_path__ + "static/pic03@4x-c9817e4517e65845642d63c035977183.jpg";